export const content = {
  it: {
    nav: {
      how: "Come funziona",
      ecosystem: "App & Kiosk",
      wall: "Wall Box",
      menu: "Menu",
      locations: "Locali",
      franchise: "Franchising",
      simulator: "Simulatore",
      cta: "Apri l'app",
    },
    hero: {
      kicker: "CUCINA ITALIANA · 100% GLUTEN FREE · AUTOMATIZZATA",
      line1: "Il ristorante",
      line2: "che si serve",
      line3: "da solo.",
      lead: "Cucina italiana 100% gluten-free preparata da MICHELCHEF® con tecnologia MAGNETRON in 5 minuti, ritirata dal Food-Box Wall. Zero coda, zero contatti.",
      ctaPrimary: "Ordina ora",
      ctaSecondary: "Diventa partner",
    },
    marquee: ["100% GLUTEN FREE", "MAGNETRON · 5 MIN", "ZERO CODA", "BUONI SSN", "FOOD-BOX WALL", "MICHELCHEF®"],
    stats: [
      { value: 12, prefix: "€ ", suffix: "", label: "Ticket medio" },
      { value: 180, prefix: "", suffix: "+", label: "Scontrini/giorno" },
      { value: 90, prefix: "€ ", suffix: "k", label: "Investimento" },
      { value: 24, prefix: "", suffix: " mesi", label: "ROI atteso" },
    ],
    market: {
      label: "Il mercato",
      pre: "Il mercato gluten-free cresce del",
      big: "+30%",
      post: "l'anno",
      body: "Oltre 220.000 celiaci in Italia + 6 milioni di consumatori occasionali. RISORICE® è l'unico format automatizzato 100% gluten-free con buoni SSN accettati.",
    },
    how: {
      label: "Come funziona",
      title: "3 passi. 5 minuti. Zero attese.",
      steps: [
        { n: "01", title: "Ordina dall'app", body: "Sfoglia il menu, componi la tua bowl e paga in 30 secondi." },
        { n: "02", title: "MICHELCHEF® cucina", body: "La cottura MAGNETRON prepara il tuo piatto in 5 minuti." },
        { n: "03", title: "Ritira dal Wall", body: "Sblocca il tuo food box con QR o PIN dall'app. Zero coda, zero attesa." },
      ],
    },
    ecosystem: {
      label: "App, Kiosk, Monitor & Kitchen Display",
      title: "Dallo smartphone del cliente allo schermo del cuoco",
      subtitle: "L'ecosistema RISORICE® connette ogni touchpoint dello store.",
      cards: [
        { tag: "iOS · ANDROID", title: "App Mobile", body: "Il ristorante in tasca: ordina, paga e ritira." },
        { tag: "iPad Kiosk", title: "Kiosk in-store", body: "Ordina senza scaricare l'app." },
        { tag: "iPad · TV 4K", title: "Monitor Menu", body: "Selezione piatti a schermo intero." },
        { tag: "iPad KDS", title: "Kitchen Display (KDS)", body: "Stato ordini in cucina in real-time." },
      ],
    },
    michelchef: {
      label: "MICHELCHEF®",
      kicker: "COTTURA MAGNETRON · PROCESSO AUTOMATIZZATO",
      title: "Ogni piatto perfetto, ogni volta.",
      body: "MICHELCHEF® è il sistema di cottura MAGNETRON automatizzato che bilancia potenza, tempo e umidità per ogni singolo piatto. Nessuna variabilità umana, standard qualitativi costanti, velocità da fast-food.",
      points: [
        "Cottura MAGNETRON con sensori intelligenti — precisione ±1°C",
        "5 minuti da ordine confermato a piatto pronto",
        "Shelf-life materie prime: 365 giorni senza perdita di qualità",
        "Ciclo di pulizia automatico a fine servizio",
        "100% gluten-free · linea separata anti-contaminazione",
      ],
      badge: "MAGNETRON · 5 min · +100 piatti/h",
    },
    wall: {
      label: "Food-Box Wall",
      kicker: "WALL SMART · MODULARE · SCALABILE",
      title: "Il futuro del ritiro cibo.",
      body: "Il Wall Box è il cuore visivo dello store: un muro di food-box modulari termoregolati che il cliente sblocca con QR o PIN direttamente dall'app. Ogni box ha display LED, sensore di presenza e serratura smart.",
      features: [
        { n: "1", title: "Display touch", body: "Il cliente inserisce il codice PIN o scansiona il QR dell'ordine." },
        { n: "2", title: "6-12 Food-Box", body: "Sportelli modulari termoregolati, LED con numero ordine." },
        { n: "3", title: "Serrature smart", body: "Apertura automatica solo dopo verifica QR/PIN, ciclo di richiusura." },
        { n: "4", title: "Sensore presenza", body: "Notifica push al cliente quando il piatto è pronto e disponibile." },
      ],
    },
    certifications: {
      label: "Certificazioni & Garanzie",
      title: "Un format unico, tracciato e conforme.",
      items: [
        { title: "Spiga Barrata AIC", body: "Certificazione ufficiale Associazione Italiana Celiachia — cucina 100% gluten-free tracciata." },
        { title: "ISO 9001:2015", body: "Sistema di gestione qualità certificato per tutti i processi produttivi e di servizio." },
        { title: "Buoni SSN Celiaci", body: "Accettiamo e rimborsiamo direttamente i buoni SSN mensili dedicati ai celiaci." },
        { title: "Shelf Life 365 giorni", body: "Materie prime a lunga conservazione senza perdita di qualità organolettica." },
      ],
    },
    ai: {
      label: "Intelligenza Artificiale",
      title: "L'AI che gestisce tutto",
      items: [
        { title: "AI Ordini", body: "Chatbot che consiglia piatti, compone bowl e gestisce allergie del cliente." },
        { title: "Riordini automatici", body: "Predice le scorte in tempo reale e piazza gli ordini fornitori sotto-scorta." },
        { title: "AI Finanza", body: "Analizza costi, margini, food-cost e ottimizza il pricing giornaliero." },
        { title: "Customer Insight", body: "Segmenta la clientela, personalizza offerte e fidelity, riduce il churn." },
      ],
    },
    menu: {
      label: "I nostri piatti",
      title: "Delivery e take-away",
      subtitle: "Menu 100% gluten-free (Spiga Barrata AIC) · packaging biodegradabile · buoni SSN celiaci accettati.",
      order: "Ordina ora",
      desc: [
        "Classica bolognese, sfoglia gluten-free, ragù di manzo lento",
        "Riso Carnaroli, porcini selezionati, mantecatura al burro",
        "Guanciale croccante, tuorlo, pecorino romano, pepe",
        "Vongole veraci, aglio, prezzemolo, olio extravergine",
        "Zafferano DOP, midollo, brodo di carne, mantecatura",
        "Frutti di mare misti, pomodorini, prezzemolo",
        "Ripieno di carne, brodo di cappone della tradizione",
        "Ragù di manzo cotto 4 ore, tagliatelle all'uovo gluten-free",
      ],
    },
    locations: {
      label: "I nostri locali",
      title: "In espansione in tutta Italia",
      items: [
        { badge: "PROSSIMA APERTURA", tag: "Store pilota", city: "ROMA", addr: "Via A. De Gasperi · vicino al Vaticano", mode: "Delivery & Take-Away" },
        { badge: "Q2 2026", tag: "", city: "BOLOGNA", addr: "Via Pradazzo · Zona Aeroporto", mode: "Posti a sedere · Delivery & Take-Away" },
        { badge: "Q3 2026", tag: "PROSSIMA APERTURA", city: "MILANO", addr: "Via Mercato, 10", mode: "Delivery & Take-Away" },
      ],
    },
    venueLayout: {
      label: "Il locale",
      title: "Il layout del locale",
      subtitle: "Store pilota di Roma — Via A. De Gasperi 44. Sala vendite con parete Wall Box, laboratorio, magazzino e bagno in soli ~30/40 m².",
      caption: "Render dello store · Sala vendite + Wall Box",
      alt: "Render del locale RISORICE Roma",
      cityTag: "RISORICE Roma",
      planAlt: "Planimetria tecnica 3D del locale con quote e metrature",
      planCaption: "Planimetria tecnica 3D · quote e metrature",
    },
    venue: {
      label: "AI Venue Analyzer",
      kicker: "POWERED BY AI VISION",
      sectionTitle: "AI Venue Analyzer",
      sectionSub: "Carica planimetria e foto: la nostra AI ti dice se la location è vincente.",
      sqmLabel: "Superficie (mq)",
      budgetLabel: "Budget indicativo (€)",
      noteLabel: "Note aggiuntive (opzionale)",
      notePlaceholder: "vincoli, orientamento, dettagli zona...",
      title: "Progetta il tuo RISORICE®",
      subtitle: "Carica planimetria e foto del locale: la nostra AI genera in ~60 secondi il progetto di layout, il conto economico e la valutazione della location.",
      planLabel: "1. Planimetria (obbligatoria)",
      planCta: "Carica planimetria",
      planHint: "JPG / PNG · max 10 MB",
      photosLabel: "2. Foto del locale (max 5, opzionale)",
      photosCta: "Aggiungi foto",
      generate: "Genera progetto AI",
      generating: "Analisi in corso...",
      privacy: "I dati caricati sono usati solo per generare il report. Nessuna condivisione con terzi.",
      errorPlan: "Carica prima la planimetria.",
      errorGen: "Analisi non riuscita, riprova.",
      resultTitle: "Report AI",
      scoreLabel: "Location score",
      econLabel: "Conto economico stimato",
      prosLabel: "Punti di forza",
      consLabel: "Criticità",
      layoutLabel: "Layout consigliato",
      recoLabel: "Raccomandazioni",
      formatLabel: "Format consigliato",
      econKeys: { investimento: "Investimento", ticketMedio: "Ticket medio", scontriniGiorno: "Scontrini/giorno", roiMesi: "ROI atteso", fatturatoAnno: "Fatturato/anno" },
      suggestTitle: "Non hai una location?",
      suggestBody: "Inserisci una città o zona: l'AI ragiona, per te.",
      suggestCta: "Chiedi all'AI",
      suggestPlaceholder: "Es. Milano, A1 Bologna-Firenze, Napoli tangenziale...",
      suggestNeedLocation: "Inserisci una città o zona per continuare.",
      suggesting: "Sto pensando...",
      suggestScore: "Score",
      suggestTicket: "Ticket medio",
      suggestNearby: "Vie limitrofe consigliate",
      suggestRentLabel: "Affitto medio 30/40 mq",
      suggestMapLabel: "Posizione sulla mappa",
      macroStreetsLabel: "Vie consigliate",
      strengthsLabel: "Punti di forza",
      passaggioLabel: "Passaggio",
      parcheggioLabel: "Parcheggio",
      utentiLabel: "Categoria utenti",
      ticketAvgLabel: "Scontrino medio",
      receiptsDayLabel: "Scontrini/giorno (18h)",
    },
    franchise: {
      label: "Franchising",
      title: "Diventa partner RISORICE®",
      subtitle: "Un modello di business esclusivo che unisce tecnologia, cucina italiana gluten-free e format scalabile. Ti seguiamo dall'idea all'apertura, con supporto marketing, formazione e software gestionale in cloud.",
      benefits: [
        { title: "Food-Box Wall", body: "Ritiro con QR o PIN. Zero code, zero contatti, zero errori." },
        { title: "AI Concierge", body: "Assistente virtuale che consiglia piatti e gestisce allergie." },
        { title: "Cottura MAGNETRON 5 min", body: "MICHELCHEF® cuoce ogni piatto in 300 secondi, standard costanti 24/7." },
        { title: "AI Gestionale", body: "Riordini automatici, controllo margini, previsioni vendite." },
        { title: "100% Gluten-Free", body: "Cucina certificata AIC. Buoni SSN celiaci accettati in cassa." },
        { title: "Scalabile", body: "Da 20 m² con wall a 6 box fino a store da 60 m² con 12+ box." },
      ],
      formTitle: "Richiedi informazioni",
      formSubtitle: "Ti richiamiamo entro 48 ore.",
      form: {
        name: "Nome e cognome",
        email: "Email",
        phone: "Telefono",
        city: "Città di interesse",
        budget: "Budget d'investimento",
        budgetOptions: ["Meno di 50k€", "50k€ – 100k€", "100k€ – 200k€", "Oltre 200k€"],
        message: "Raccontaci di te (opzionale)",
        submit: "Invia richiesta",
        sending: "Invio in corso...",
        success: "Richiesta inviata! Ti richiamiamo entro 48 ore.",
        error: "Errore nell'invio. Riprova.",
      },
    },
    footer: {
      tagline: "Cucina italiana automatizzata · 100% gluten-free · Delivery & take-away",
      contact: "Contatti",
      emails: ["info@risorice.it", "franchising@risorice.it"],
      company: "RISORICE® S.r.l. · ROMA",
      certTitle: "Certificazioni",
      certs: ["Spiga Barrata AIC", "ISO 9001:2015", "Buoni SSN celiaci"],
      rights: "© 2026 RISORICE® · Tutti i diritti riservati",
      nav: "Navigazione",
    },
    franchisingPage: {
      kicker: "FRANCHISING · ITALIA",
      title: "Apri il tuo RISORICE®",
      subtitle: "La cucina italiana gluten-free automatizzata. Un modello di ristorazione unico che unisce cottura automatica, AI e Food-Box Wall.",
      stats: [
        { prefix: "€ ", value: 12, suffix: "", label: "Ticket medio" },
        { prefix: "", value: 180, suffix: "+", label: "Coperti/gg possibili" },
        { prefix: "€ ", value: 90, suffix: "k", label: "Investimento iniziale" },
        { prefix: "", value: 24, suffix: " mesi", label: "ROI atteso" },
      ],
      benefitsTitle: "Perché scegliere RISORICE®",
      benefitsSub: "6 vantaggi competitivi che ci differenziano",
      benefits: [
        { title: "Food-Box Wall", body: "Wall automatizzato: il cliente ritira il suo box con QR/PIN, zero coda in cassa." },
        { title: "AI Concierge", body: "Chatbot che consiglia i piatti, compone bowl, gestisce allergie e preferenze." },
        { title: "5 minuti di cottura", body: "Tutti i piatti pronti in 5 minuti da cucina centralizzata certificata gluten-free." },
        { title: "Buoni SSN Celiaci", body: "Accettiamo direttamente i buoni SSN — sistema di redemption integrato." },
        { title: "Gestionale integrato", body: "Dashboard admin per ordini in tempo reale, statistiche vendite e riordini." },
        { title: "Location scalabile", body: "Wall configurabile da 6 a 12+ box in base allo spazio del tuo locale." },
      ],
      stepsTitle: "Come funziona",
      steps: [
        { n: "1", title: "Contatto", body: "Compili il form contatti — ti richiamiamo entro 48h." },
        { n: "2", title: "Assessment", body: "Valutazione locale + business plan personalizzato per la tua zona." },
        { n: "3", title: "Installazione", body: "Wall Box, cucina automatizzata MAGNETRON e app brandizzata." },
        { n: "4", title: "Formazione", body: "Training staff + supporto marketing e gestionale in cloud." },
      ],
      simCtaTitle: "Vuoi sapere come finanziare il tuo RISORICE®?",
      simCtaBody: "Apri il simulatore: analisi completa dell'investimento €90k, rate mensili, break-even scontrini e payback.",
      simCtaBtn: "Apri simulatore",
      assessTitle: "Valutazione locale con AI",
      assessSub: "Carica la planimetria e ottieni una stima immediata di layout, conto economico e idoneità.",
      formTitle: "Richiedi informazioni",
      formSubtitle: "Ti richiameremo entro 48 ore.",
    },
    simulator: {
      kicker: "SIMULATORE INVESTIMENTO",
      title: "Come finanzi i tuoi € 90.000?",
      subtitle: "Simula la rata mensile, calcola il break-even scontrini e stima il payback del tuo RISORICE®. Analisi completa — 100% indicativa e senza registrazione.",
      breakdownTitle: "Come sono composti i € 90k",
      breakdown: [
        { label: "Franchise fee & royalty setup", value: "€ 15.000" },
        { label: "Wall Box + attrezzature MAGNETRON", value: "€ 35.000" },
        { label: "Arredi & allestimento locale", value: "€ 18.000" },
        { label: "Installazione, impianti, insegne", value: "€ 12.000" },
        { label: "Marketing lancio & scorte iniziali", value: "€ 7.000" },
        { label: "Contingency (5%)", value: "€ 3.000" },
      ],
      modeTitle: "1. Scegli la modalità di finanziamento",
      modes: [
        { key: "banca", label: "Banca", desc: "Finanziamento bancario classico con anticipo e piano di ammortamento francese. Tasso soggetto a istruttoria e merito creditizio." },
        { key: "leasing", label: "Leasing", desc: "Leasing strumentale sulle attrezzature con riscatto finale. Anticipo ridotto e vantaggi fiscali sulla deducibilità dei canoni." },
        { key: "noleggio", label: "Noleggio", desc: "Canone mensile fisso all-inclusive per l'intero setup RISORICE®: attrezzature, assicurazione, manutenzione e supporto. Nessun anticipo richiesto." },
      ],
      paramsTitle: "2. Anticipo e durata",
      anticipoLabel: "Anticipo",
      durataLabel: "Durata",
      tanLabel: "TAN",
      months: "mesi",
      rateTitle: "3. La tua rata",
      rateSuffix: "al mese · per",
      anticipoIniziale: "Anticipo iniziale",
      totInteressi: "Totale interessi",
      costoTotale: "Costo totale operazione",
      beTitle: "4. Break-even — quanto devi vendere",
      beIntro: "Partiamo da un'ipotesi prudenziale di 60 scontrini/giorno. RISORICE® opera 18-24h/g, quindi 150-260 scontrini/gg sono raggiungibili.",
      ticketLabel: "Ticket medio",
      scontriniLabel: "Scontrini/giorno",
      beCover: "scontrini/giorno per coprire solo la rata",
      beDailyCost: "Costo rata giornaliero",
      beYourEst: "Tua stima",
      beSafety: "Margine di sicurezza",
      paybackTitle: "5. Payback — quando rientri",
      marginLabel: "Margine netto operativo",
      ricavoMensile: "Ricavo mensile stimato",
      utileNetto: "Utile netto post-rata",
      utileSuffix: "al mese",
      paybackLabel: "Payback investimento",
      paybackYears: "anni",
      amortTitle: "6. Ammortamento — primi 6 mesi",
      amortIntro: "Dettaglio quota capitale e quota interessi sui primi mesi del piano.",
      amortCols: ["Mese", "Rata", "Interessi", "Capitale", "Debito residuo"],
      disclaimer: "Simulazione puramente indicativa. Tassi (TAN), anticipo e durate dipendono dall'istruttoria di banche e società di leasing, dal merito creditizio e da eventuali incentivi (Nuova Sabatini, ISMEA, Invitalia Resto al Sud). Ricavi e margini sono medie di riferimento del format RISORICE® e variano in base alla location. Non costituisce offerta né consulenza finanziaria.",
      bpBadge: "SERVIZIO PREMIUM · € 99",
      bpTitle: "Vuoi un Business Plan bancabile?",
      bpBody: "Realizziamo un business plan professionale + pitch da portare in banca, tarato sulla tua location. Analisi finanziaria, proiezioni 5 anni, break-even, ROI e piano investimenti.",
      bpFeatures: [
        "Business Plan completo (25-40 pagine) in PDF",
        "Pitch deck bancabile (15 slide) in PDF & PPT",
        "Conto economico dettagliato · Cash flow triennale",
        "Piano investimenti + fabbisogno finanziario",
        "Analisi di mercato personalizzata sulla tua location",
        "Consegna via email entro 7 giorni lavorativi",
      ],
      bpPrice: "€ 99,00",
      bpPriceNote: "una tantum · IVA inclusa",
      bpButton: "Richiedi il business plan",
      bpNote: "Serve la planimetria del locale, alcune foto interne ed esterne e l'indirizzo — così stimiamo i lavori e verifichiamo i parcheggi.",
      bpModal: {
        title: "I tuoi dati",
        subtitle: "Inserisci i tuoi dati prima di procedere al pagamento: ci servono per sapere chi acquista e a chi inviare il Business Plan.",
        name: "Nome e cognome",
        email: "Email",
        phone: "Telefono",
        city: "Città / Location del locale",
        submit: "Procedi al pagamento · € 99",
        cancel: "Annulla",
        required: "Inserisci nome ed email validi.",
      },
      brochure: {
        badge: "Dossier investitori",
        title: "Scarica la brochure per investitori",
        body: "Un documento sintetico e d'impatto: visione, modello, numeri del simulatore, ROI e sicurezza. Perché RISORICE punta a diventare più grande di McDonald's.",
        cta: "Scarica PDF",
        formTitle: "Prima di scaricare",
        formSubtitle: "Inserisci i tuoi dati per ricevere la brochure per investitori.",
        name: "Nome e cognome",
        email: "Email",
        phone: "Telefono",
        submit: "Scarica la brochure",
        sending: "Attendi...",
        required: "Inserisci nome, email e telefono validi.",
        downloading: "Download avviato!",
        shareLabel: "Condividi la brochure",
        shareWhatsapp: "WhatsApp",
        shareEmail: "Email",
        shareText: "Scopri RISORICE — la brochure per investitori:",
        emailSubject: "RISORICE — Brochure per investitori",
      },
      ctaTitle: "Convinto dai numeri?",
      ctaBody: "Compila il form e ti richiamiamo entro 48h con un business plan personalizzato per la tua zona.",
    },
  },

  en: {
    nav: {
      how: "How it works",
      ecosystem: "App & Kiosk",
      wall: "Wall Box",
      menu: "Menu",
      locations: "Stores",
      franchise: "Franchising",
      simulator: "Simulator",
      cta: "Open the app",
    },
    hero: {
      kicker: "ITALIAN CUISINE · 100% GLUTEN FREE · AUTOMATED",
      line1: "The restaurant",
      line2: "that serves",
      line3: "itself.",
      lead: "100% gluten-free Italian cuisine cooked by MICHELCHEF® with MAGNETRON technology in 5 minutes, collected from the Food-Box Wall. Zero queue, zero contact.",
      ctaPrimary: "Order now",
      ctaSecondary: "Become a partner",
    },
    marquee: ["100% GLUTEN FREE", "MAGNETRON · 5 MIN", "ZERO QUEUE", "SSN VOUCHERS", "FOOD-BOX WALL", "MICHELCHEF®"],
    stats: [
      { value: 12, prefix: "€ ", suffix: "", label: "Avg. ticket" },
      { value: 180, prefix: "", suffix: "+", label: "Receipts/day" },
      { value: 90, prefix: "€ ", suffix: "k", label: "Investment" },
      { value: 24, prefix: "", suffix: " mo.", label: "Expected ROI" },
    ],
    market: {
      label: "The market",
      pre: "The gluten-free market grows by",
      big: "+30%",
      post: "a year",
      body: "Over 220,000 coeliacs in Italy + 6 million occasional consumers. RISORICE® is the only 100% gluten-free automated format accepting SSN vouchers.",
    },
    how: {
      label: "How it works",
      title: "3 steps. 5 minutes. Zero waiting.",
      steps: [
        { n: "01", title: "Order from the app", body: "Browse the menu, build your bowl and pay in 30 seconds." },
        { n: "02", title: "MICHELCHEF® cooks", body: "MAGNETRON cooking prepares your dish in 5 minutes." },
        { n: "03", title: "Collect from the Wall", body: "Unlock your food box with QR or PIN from the app. Zero queue." },
      ],
    },
    ecosystem: {
      label: "App, Kiosk, Monitor & Kitchen Display",
      title: "From the customer's phone to the cook's screen",
      subtitle: "The RISORICE® ecosystem connects every touchpoint in the store.",
      cards: [
        { tag: "iOS · ANDROID", title: "Mobile App", body: "The restaurant in your pocket: order, pay, collect." },
        { tag: "iPad Kiosk", title: "In-store Kiosk", body: "Order without downloading the app." },
        { tag: "iPad · TV 4K", title: "Menu Monitor", body: "Full-screen dish selection." },
        { tag: "iPad KDS", title: "Kitchen Display (KDS)", body: "Real-time order status in the kitchen." },
      ],
    },
    michelchef: {
      label: "MICHELCHEF®",
      kicker: "MAGNETRON COOKING · AUTOMATED PROCESS",
      title: "Every dish perfect, every time.",
      body: "MICHELCHEF® is the automated MAGNETRON cooking system that balances power, time and humidity for every single dish. No human variability, constant quality standards, fast-food speed.",
      points: [
        "MAGNETRON cooking with smart sensors — ±1°C precision",
        "5 minutes from confirmed order to ready dish",
        "Ingredient shelf-life: 365 days without quality loss",
        "Automatic cleaning cycle at end of service",
        "100% gluten-free · separate anti-contamination line",
      ],
      badge: "MAGNETRON · 5 min · +100 dishes/h",
    },
    wall: {
      label: "Food-Box Wall",
      kicker: "SMART WALL · MODULAR · SCALABLE",
      title: "The future of food pickup.",
      body: "The Wall Box is the visual heart of the store: a wall of temperature-controlled modular food-boxes the customer unlocks with QR or PIN straight from the app. Each box has an LED display, presence sensor and smart lock.",
      features: [
        { n: "1", title: "Touch display", body: "The customer enters the PIN code or scans the order QR." },
        { n: "2", title: "6-12 Food-Boxes", body: "Modular temperature-controlled doors, LED with order number." },
        { n: "3", title: "Smart locks", body: "Auto-open only after QR/PIN verification, re-lock cycle." },
        { n: "4", title: "Presence sensor", body: "Push notification when the dish is ready and available." },
      ],
    },
    certifications: {
      label: "Certifications & Guarantees",
      title: "A unique, traceable, compliant format.",
      items: [
        { title: "AIC Crossed Grain", body: "Official Italian Coeliac Association certification — traceable 100% gluten-free kitchen." },
        { title: "ISO 9001:2015", body: "Certified quality management system across all production and service processes." },
        { title: "SSN Coeliac Vouchers", body: "We accept and reimburse the monthly SSN vouchers dedicated to coeliacs." },
        { title: "365-day Shelf Life", body: "Long-life ingredients with no loss of organoleptic quality." },
      ],
    },
    ai: {
      label: "Artificial Intelligence",
      title: "The AI that runs everything",
      items: [
        { title: "AI Orders", body: "Chatbot that suggests dishes, builds bowls and manages customer allergies." },
        { title: "Auto reorders", body: "Predicts stock in real time and places supplier orders when low." },
        { title: "AI Finance", body: "Analyzes costs, margins, food-cost and optimizes daily pricing." },
        { title: "Customer Insight", body: "Segments customers, personalizes offers and loyalty, reduces churn." },
      ],
    },
    menu: {
      label: "Our dishes",
      title: "Delivery & take-away",
      subtitle: "100% gluten-free menu (AIC Crossed Grain) · biodegradable packaging · SSN coeliac vouchers accepted.",
      order: "Order now",
      desc: [
        "Classic bolognese, gluten-free sheets, slow beef ragù",
        "Carnaroli rice, selected porcini, butter mantecatura",
        "Crispy guanciale, egg yolk, pecorino romano, pepper",
        "Fresh clams, garlic, parsley, extra-virgin olive oil",
        "DOP saffron, marrow, meat broth, mantecatura",
        "Mixed seafood, cherry tomatoes, parsley",
        "Meat filling, traditional capon broth",
        "4-hour beef ragù, gluten-free egg tagliatelle",
      ],
    },
    locations: {
      label: "Our stores",
      title: "Expanding across Italy",
      items: [
        { badge: "OPENING SOON", tag: "Pilot store", city: "ROME", addr: "Via A. De Gasperi · near the Vatican", mode: "Delivery & Take-Away" },
        { badge: "Q2 2026", tag: "", city: "BOLOGNA", addr: "Via Pradazzo · Airport area", mode: "Seating · Delivery & Take-Away" },
        { badge: "Q3 2026", tag: "OPENING SOON", city: "MILAN", addr: "Via Mercato, 10", mode: "Delivery & Take-Away" },
      ],
    },
    venueLayout: {
      label: "The venue",
      title: "The venue layout",
      subtitle: "Rome pilot store — Via A. De Gasperi 44. Sales floor with the Wall Box wall, lab, storage and restroom in just ~30/40 m².",
      caption: "Store render · Sales floor + Wall Box",
      alt: "Render of the RISORICE Rome venue",
      cityTag: "RISORICE Rome",
      planAlt: "3D technical floor plan of the venue with dimensions",
      planCaption: "3D technical floor plan · dimensions",
    },
    venue: {
      label: "AI Venue Analyzer",
      kicker: "POWERED BY AI VISION",
      sectionTitle: "AI Venue Analyzer",
      sectionSub: "Upload the floor plan and photos: our AI tells you if the location is a winner.",
      sqmLabel: "Area (sqm)",
      budgetLabel: "Indicative budget (€)",
      noteLabel: "Additional notes (optional)",
      notePlaceholder: "constraints, orientation, area details...",
      title: "Design your RISORICE®",
      subtitle: "Upload the floor plan and photos of the venue: our AI generates the layout project, the P&L and the location assessment in ~60 seconds.",
      planLabel: "1. Floor plan (required)",
      planCta: "Upload floor plan",
      planHint: "JPG / PNG · max 10 MB",
      photosLabel: "2. Venue photos (max 5, optional)",
      photosCta: "Add photos",
      generate: "Generate AI project",
      generating: "Analyzing...",
      privacy: "Uploaded data is used only to generate the report. No sharing with third parties.",
      errorPlan: "Please upload the floor plan first.",
      errorGen: "Analysis failed, please retry.",
      resultTitle: "AI Report",
      scoreLabel: "Location score",
      econLabel: "Estimated P&L",
      prosLabel: "Strengths",
      consLabel: "Weaknesses",
      layoutLabel: "Suggested layout",
      recoLabel: "Recommendations",
      formatLabel: "Suggested format",
      econKeys: { investimento: "Investment", ticketMedio: "Avg. ticket", scontriniGiorno: "Receipts/day", roiMesi: "Expected ROI", fatturatoAnno: "Revenue/year" },
      suggestTitle: "No location yet?",
      suggestBody: "Enter a city or area: the AI reasons, for you.",
      suggestCta: "Ask the AI",
      suggestPlaceholder: "E.g. Milan, A1 Bologna-Florence, Naples ring road...",
      suggestNeedLocation: "Enter a city or area to continue.",
      suggesting: "Thinking...",
      suggestScore: "Score",
      suggestTicket: "Avg. ticket",
      suggestNearby: "Recommended nearby streets",
      suggestRentLabel: "Avg. rent 30/40 sqm",
      suggestMapLabel: "Location on map",
      macroStreetsLabel: "Recommended streets",
      strengthsLabel: "Strengths",
      passaggioLabel: "Footfall",
      parcheggioLabel: "Parking",
      utentiLabel: "User category",
      ticketAvgLabel: "Avg. ticket",
      receiptsDayLabel: "Receipts/day (18h)",
    },
    franchise: {
      label: "Franchising",
      title: "Become a RISORICE® partner",
      subtitle: "An exclusive business model combining technology, gluten-free Italian cuisine and a scalable format. We support you from idea to opening, with marketing, training and cloud management software.",
      benefits: [
        { title: "Food-Box Wall", body: "Pickup with QR or PIN. Zero queue, zero contact, zero errors." },
        { title: "AI Concierge", body: "Virtual assistant that recommends dishes and manages allergies." },
        { title: "5-min MAGNETRON cooking", body: "MICHELCHEF® cooks every dish in 300 seconds, constant 24/7." },
        { title: "AI Management", body: "Auto reorders, margin control, sales forecasting." },
        { title: "100% Gluten-Free", body: "AIC-certified kitchen. SSN coeliac vouchers accepted." },
        { title: "Scalable", body: "From 20 m² with a 6-box wall up to 60 m² stores with 12+ boxes." },
      ],
      formTitle: "Request information",
      formSubtitle: "We'll call you back within 48 hours.",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        city: "City of interest",
        budget: "Investment budget",
        budgetOptions: ["Under €50k", "€50k – €100k", "€100k – €200k", "Over €200k"],
        message: "Tell us about you (optional)",
        submit: "Send request",
        sending: "Sending...",
        success: "Request sent! We'll call you back within 48 hours.",
        error: "Sending failed. Please retry.",
      },
    },
    footer: {
      tagline: "Automated Italian cuisine · 100% gluten-free · Delivery & take-away",
      contact: "Contact",
      emails: ["info@risorice.it", "franchising@risorice.it"],
      company: "RISORICE® S.r.l. · ROMA",
      certTitle: "Certifications",
      certs: ["AIC Crossed Grain", "ISO 9001:2015", "SSN coeliac vouchers"],
      rights: "© 2026 RISORICE® · All rights reserved",
      nav: "Navigation",
    },
    franchisingPage: {
      kicker: "FRANCHISING · ITALY",
      title: "Open your RISORICE®",
      subtitle: "Automated gluten-free Italian cuisine. A unique restaurant model combining automatic cooking, AI and the Food-Box Wall.",
      stats: [
        { prefix: "€ ", value: 12, suffix: "", label: "Avg. ticket" },
        { prefix: "", value: 180, suffix: "+", label: "Covers/day possible" },
        { prefix: "€ ", value: 90, suffix: "k", label: "Initial investment" },
        { prefix: "", value: 24, suffix: " mo.", label: "Expected ROI" },
      ],
      benefitsTitle: "Why choose RISORICE®",
      benefitsSub: "6 competitive advantages that set us apart",
      benefits: [
        { title: "Food-Box Wall", body: "Automated wall: the customer picks up their box with QR/PIN, zero queue at the till." },
        { title: "AI Concierge", body: "Chatbot that recommends dishes, builds bowls, manages allergies and preferences." },
        { title: "5-minute cooking", body: "Every dish ready in 5 minutes from a certified gluten-free central kitchen." },
        { title: "SSN Coeliac Vouchers", body: "We accept SSN vouchers directly — integrated redemption system." },
        { title: "Integrated management", body: "Admin dashboard for real-time orders, sales stats and reorders." },
        { title: "Scalable location", body: "Wall configurable from 6 to 12+ boxes depending on your space." },
      ],
      stepsTitle: "How it works",
      steps: [
        { n: "1", title: "Contact", body: "Fill in the contact form — we call you back within 48h." },
        { n: "2", title: "Assessment", body: "Venue evaluation + personalized business plan for your area." },
        { n: "3", title: "Installation", body: "Wall Box, automated MAGNETRON kitchen and branded app." },
        { n: "4", title: "Training", body: "Staff training + marketing and cloud management support." },
      ],
      simCtaTitle: "Want to know how to finance your RISORICE®?",
      simCtaBody: "Open the simulator: full analysis of the €90k investment, monthly instalments, receipts break-even and payback.",
      simCtaBtn: "Open simulator",
      assessTitle: "AI venue assessment",
      assessSub: "Upload the floor plan and get an instant estimate of layout, P&L and suitability.",
      formTitle: "Request information",
      formSubtitle: "We'll call you back within 48 hours.",
    },
    simulator: {
      kicker: "INVESTMENT SIMULATOR",
      title: "How do you finance your € 90,000?",
      subtitle: "Simulate the monthly instalment, compute the receipts break-even and estimate the payback of your RISORICE®. Full analysis — 100% indicative, no sign-up.",
      breakdownTitle: "How the € 90k breaks down",
      breakdown: [
        { label: "Franchise fee & royalty setup", value: "€ 15,000" },
        { label: "Wall Box + MAGNETRON equipment", value: "€ 35,000" },
        { label: "Furniture & venue fit-out", value: "€ 18,000" },
        { label: "Installation, systems, signage", value: "€ 12,000" },
        { label: "Launch marketing & initial stock", value: "€ 7,000" },
        { label: "Contingency (5%)", value: "€ 3,000" },
      ],
      modeTitle: "1. Choose the financing mode",
      modes: [
        { key: "banca", label: "Bank", desc: "Classic bank loan with down payment and French amortization plan. Rate subject to credit assessment." },
        { key: "leasing", label: "Leasing", desc: "Equipment leasing with final buyout. Lower down payment and tax benefits on deductible instalments." },
        { key: "noleggio", label: "Rental", desc: "Fixed all-inclusive monthly fee for the whole RISORICE® setup: equipment, insurance, maintenance and support. No down payment required." },
      ],
      paramsTitle: "2. Down payment and term",
      anticipoLabel: "Down payment",
      durataLabel: "Term",
      tanLabel: "APR",
      months: "months",
      rateTitle: "3. Your instalment",
      rateSuffix: "per month · for",
      anticipoIniziale: "Initial down payment",
      totInteressi: "Total interest",
      costoTotale: "Total operation cost",
      beTitle: "4. Break-even — how much you must sell",
      beIntro: "We start from a prudent assumption of 60 receipts/day. RISORICE® operates 18-24h/day, so 150-260 receipts/day are achievable.",
      ticketLabel: "Avg. ticket",
      scontriniLabel: "Receipts/day",
      beCover: "receipts/day just to cover the instalment",
      beDailyCost: "Daily instalment cost",
      beYourEst: "Your estimate",
      beSafety: "Safety margin",
      paybackTitle: "5. Payback — when you break even",
      marginLabel: "Net operating margin",
      ricavoMensile: "Estimated monthly revenue",
      utileNetto: "Net profit post-instalment",
      utileSuffix: "per month",
      paybackLabel: "Investment payback",
      paybackYears: "years",
      amortTitle: "6. Amortization — first 6 months",
      amortIntro: "Principal and interest split over the first months of the plan.",
      amortCols: ["Month", "Instalment", "Interest", "Principal", "Residual debt"],
      disclaimer: "Purely indicative simulation. Rates (APR), down payment and terms depend on the assessment by banks and leasing companies, on creditworthiness and on any incentives. Revenues and margins are RISORICE® format averages and vary by location. This is not an offer nor financial advice.",
      bpBadge: "PREMIUM SERVICE · € 99",
      bpTitle: "Want a bankable Business Plan?",
      bpBody: "We produce a professional business plan + pitch to bring to the bank, tailored to your location. Financial analysis, 5-year projections, break-even, ROI and investment plan.",
      bpFeatures: [
        "Full Business Plan (25-40 pages) in PDF",
        "Bankable pitch deck (15 slides) in PDF & PPT",
        "Detailed P&L · 3-year cash flow",
        "Investment plan + financing needs",
        "Market analysis tailored to your location",
        "Delivered by email within 7 business days",
      ],
      bpPrice: "€ 99.00",
      bpPriceNote: "one-off · VAT included",
      bpButton: "Request the business plan",
      bpNote: "We need the venue floor plan, some interior/exterior photos and the address — so we can estimate renovation works and check parking.",
      bpModal: {
        title: "Your details",
        subtitle: "Enter your details before proceeding to payment: we need to know who is buying and where to send the Business Plan.",
        name: "Full name",
        email: "Email",
        phone: "Phone",
        city: "City / Venue location",
        submit: "Proceed to payment · € 99",
        cancel: "Cancel",
        required: "Please enter a valid name and email.",
      },
      brochure: {
        badge: "Investor brochure",
        title: "Download the investor brochure",
        body: "A concise, high-impact document: vision, model, simulator figures, ROI and safety. Why RISORICE aims to become bigger than McDonald's.",
        cta: "Download PDF",
        formTitle: "Before downloading",
        formSubtitle: "Enter your details to receive the investor brochure.",
        name: "Full name",
        email: "Email",
        phone: "Phone",
        submit: "Download the brochure",
        sending: "Please wait...",
        required: "Please enter a valid name, email and phone.",
        downloading: "Download started!",
        shareLabel: "Share the brochure",
        shareWhatsapp: "WhatsApp",
        shareEmail: "Email",
        shareText: "Discover RISORICE — the investor brochure:",
        emailSubject: "RISORICE — Investor brochure",
      },
      ctaTitle: "Convinced by the numbers?",
      ctaBody: "Fill in the form and we'll call you back within 48h with a personalized business plan for your area.",
    },
  },

  ru: {
    nav: {
      how: "Как это работает",
      ecosystem: "App и Kiosk",
      wall: "Wall Box",
      menu: "Меню",
      locations: "Точки",
      franchise: "Франшиза",
      simulator: "Калькулятор",
      cta: "Открыть приложение",
    },
    hero: {
      kicker: "ИТАЛЬЯНСКАЯ КУХНЯ · 100% БЕЗ ГЛЮТЕНА · АВТОМАТИЗИРОВАНО",
      line1: "Ресторан,",
      line2: "который обслуживает",
      line3: "сам себя.",
      lead: "Итальянская кухня на 100% без глютена, приготовленная MICHELCHEF® по технологии MAGNETRON за 5 минут и выданная из стены Food-Box. Без очередей, без контакта.",
      ctaPrimary: "Заказать сейчас",
      ctaSecondary: "Стать партнёром",
    },
    marquee: ["100% БЕЗ ГЛЮТЕНА", "MAGNETRON · 5 МИН", "БЕЗ ОЧЕРЕДЕЙ", "ТАЛОНЫ SSN", "FOOD-BOX WALL", "MICHELCHEF®"],
    stats: [
      { value: 12, prefix: "€ ", suffix: "", label: "Средний чек" },
      { value: 180, prefix: "", suffix: "+", label: "Чеков/день" },
      { value: 90, prefix: "€ ", suffix: "k", label: "Инвестиции" },
      { value: 24, prefix: "", suffix: " мес.", label: "Ожидаемый ROI" },
    ],
    market: {
      label: "Рынок",
      pre: "Рынок без глютена растёт на",
      big: "+30%",
      post: "в год",
      body: "Более 220 000 больных целиакией в Италии + 6 млн периодических потребителей. RISORICE® — единственный автоматизированный формат на 100% без глютена, принимающий талоны SSN.",
    },
    how: {
      label: "Как это работает",
      title: "3 шага. 5 минут. Ноль ожидания.",
      steps: [
        { n: "01", title: "Закажите в приложении", body: "Выберите блюда, соберите свою миску и оплатите за 30 секунд." },
        { n: "02", title: "MICHELCHEF® готовит", body: "Технология MAGNETRON готовит ваше блюдо за 5 минут." },
        { n: "03", title: "Заберите из стены", body: "Откройте свой Food-Box по QR или PIN из приложения. Без очередей." },
      ],
    },
    ecosystem: {
      label: "App, Kiosk, Monitor и Kitchen Display",
      title: "От смартфона клиента до экрана повара",
      subtitle: "Экосистема RISORICE® связывает каждую точку контакта в точке продаж.",
      cards: [
        { tag: "iOS · ANDROID", title: "Мобильное приложение", body: "Ресторан в кармане: заказ, оплата, получение." },
        { tag: "iPad Kiosk", title: "Киоск в точке", body: "Заказ без установки приложения." },
        { tag: "iPad · TV 4K", title: "Меню-монитор", body: "Выбор блюд на весь экран." },
        { tag: "iPad KDS", title: "Kitchen Display (KDS)", body: "Статус заказов на кухне в реальном времени." },
      ],
    },
    michelchef: {
      label: "MICHELCHEF®",
      kicker: "ПРИГОТОВЛЕНИЕ MAGNETRON · АВТОМАТИЗИРОВАННЫЙ ПРОЦЕСС",
      title: "Каждое блюдо идеально, каждый раз.",
      body: "MICHELCHEF® — это автоматизированная система приготовления MAGNETRON, которая балансирует мощность, время и влажность для каждого блюда. Никакого человеческого фактора, постоянные стандарты качества, скорость фаст-фуда.",
      points: [
        "Приготовление MAGNETRON с умными датчиками — точность ±1°C",
        "5 минут от подтверждённого заказа до готового блюда",
        "Срок годности сырья: 365 дней без потери качества",
        "Автоматический цикл очистки в конце смены",
        "100% без глютена · отдельная линия против загрязнения",
      ],
      badge: "MAGNETRON · 5 мин · +100 блюд/ч",
    },
    wall: {
      label: "Food-Box Wall",
      kicker: "УМНАЯ СТЕНА · МОДУЛЬНАЯ · МАСШТАБИРУЕМАЯ",
      title: "Будущее выдачи еды.",
      body: "Wall Box — визуальное сердце точки: стена модульных термостатированных Food-Box, которые клиент открывает по QR или PIN прямо из приложения. У каждого бокса есть LED-дисплей, датчик присутствия и умный замок.",
      features: [
        { n: "1", title: "Сенсорный дисплей", body: "Клиент вводит PIN-код или сканирует QR заказа." },
        { n: "2", title: "6-12 Food-Box", body: "Модульные термостатированные дверцы, LED с номером заказа." },
        { n: "3", title: "Умные замки", body: "Автооткрытие только после проверки QR/PIN, цикл повторного закрытия." },
        { n: "4", title: "Датчик присутствия", body: "Push-уведомление, когда блюдо готово и доступно." },
      ],
    },
    certifications: {
      label: "Сертификаты и гарантии",
      title: "Уникальный, отслеживаемый и соответствующий формат.",
      items: [
        { title: "Перечёркнутый колос AIC", body: "Официальная сертификация Итальянской ассоциации целиакии — кухня на 100% без глютена, с отслеживанием." },
        { title: "ISO 9001:2015", body: "Сертифицированная система менеджмента качества для всех процессов производства и обслуживания." },
        { title: "Талоны SSN для целиаков", body: "Принимаем и возмещаем ежемесячные талоны SSN для больных целиакией." },
        { title: "Срок годности 365 дней", body: "Сырьё длительного хранения без потери органолептических качеств." },
      ],
    },
    ai: {
      label: "Искусственный интеллект",
      title: "ИИ, который управляет всем",
      items: [
        { title: "ИИ Заказы", body: "Чат-бот, который рекомендует блюда, собирает миски и учитывает аллергии клиента." },
        { title: "Автозаказы", body: "Прогнозирует запасы в реальном времени и оформляет заказы поставщикам при нехватке." },
        { title: "ИИ Финансы", body: "Анализирует затраты, маржу, себестоимость и оптимизирует ежедневное ценообразование." },
        { title: "Customer Insight", body: "Сегментирует клиентов, персонализирует акции и лояльность, снижает отток." },
      ],
    },
    menu: {
      label: "Наши блюда",
      title: "Доставка и навынос",
      subtitle: "Меню на 100% без глютена (перечёркнутый колос AIC) · биоразлагаемая упаковка · принимаются талоны SSN.",
      order: "Заказать сейчас",
      desc: [
        "Классическая болоньезе, тесто без глютена, медленное говяжье рагу",
        "Рис Карнароли, отборные белые грибы, сливочное мантекато",
        "Хрустящая гуанчиале, желток, пекорино романо, перец",
        "Свежие вонголе, чеснок, петрушка, оливковое масло",
        "Шафран DOP, костный мозг, мясной бульон, мантекато",
        "Ассорти из морепродуктов, черри, петрушка",
        "Мясная начинка, традиционный бульон из каплуна",
        "Говяжье рагу 4 часа, яичные тальятелле без глютена",
      ],
    },
    locations: {
      label: "Наши точки",
      title: "Расширяемся по всей Италии",
      items: [
        { badge: "СКОРО ОТКРЫТИЕ", tag: "Пилотная точка", city: "РИМ", addr: "Via A. De Gasperi · рядом с Ватиканом", mode: "Доставка и навынос" },
        { badge: "Q2 2026", tag: "", city: "БОЛОНЬЯ", addr: "Via Pradazzo · зона аэропорта", mode: "Посадочные места · доставка и навынос" },
        { badge: "Q3 2026", tag: "СКОРО ОТКРЫТИЕ", city: "МИЛАН", addr: "Via Mercato, 10", mode: "Доставка и навынос" },
      ],
    },
    venueLayout: {
      label: "Локация",
      title: "Планировка точки",
      subtitle: "Пилотная точка в Риме — Via A. De Gasperi 44. Торговый зал со стеной Wall Box, лаборатория, склад и санузел всего на ~30/40 м².",
      caption: "Рендер точки · Торговый зал + Wall Box",
      alt: "Рендер точки RISORICE в Риме",
      cityTag: "RISORICE Рим",
      planAlt: "Техническая 3D-планировка точки с размерами",
      planCaption: "Техническая 3D-планировка · размеры",
    },
    venue: {
      label: "AI Venue Analyzer",
      kicker: "POWERED BY AI VISION",
      sectionTitle: "AI Venue Analyzer",
      sectionSub: "Загрузите план и фото: наш ИИ скажет, выигрышная ли это локация.",
      sqmLabel: "Площадь (м²)",
      budgetLabel: "Ориентировочный бюджет (€)",
      noteLabel: "Дополнительные заметки (необязательно)",
      notePlaceholder: "ограничения, ориентация, детали района...",
      title: "Спроектируйте свой RISORICE®",
      subtitle: "Загрузите план и фото помещения: наш ИИ за ~60 секунд создаёт проект планировки, отчёт о прибылях и убытках и оценку локации.",
      planLabel: "1. План помещения (обязательно)",
      planCta: "Загрузить план",
      planHint: "JPG / PNG · макс. 10 МБ",
      photosLabel: "2. Фото помещения (макс. 5, необязательно)",
      photosCta: "Добавить фото",
      generate: "Создать ИИ-проект",
      generating: "Анализ...",
      privacy: "Загруженные данные используются только для создания отчёта. Без передачи третьим лицам.",
      errorPlan: "Сначала загрузите план помещения.",
      errorGen: "Анализ не удался, повторите попытку.",
      resultTitle: "ИИ-отчёт",
      scoreLabel: "Оценка локации",
      econLabel: "Оценка P&L",
      prosLabel: "Сильные стороны",
      consLabel: "Слабые стороны",
      layoutLabel: "Рекомендуемая планировка",
      recoLabel: "Рекомендации",
      formatLabel: "Рекомендуемый формат",
      econKeys: { investimento: "Инвестиции", ticketMedio: "Средний чек", scontriniGiorno: "Чеков/день", roiMesi: "Ожидаемый ROI", fatturatoAnno: "Выручка/год" },
      suggestTitle: "Пока нет локации?",
      suggestBody: "Введите город или район: ИИ подумает за вас.",
      suggestCta: "Спросить ИИ",
      suggestPlaceholder: "Напр. Милан, A1 Болонья-Флоренция, кольцевая Неаполя...",
      suggestNeedLocation: "Введите город или район, чтобы продолжить.",
      suggesting: "Думаю...",
      suggestScore: "Оценка",
      suggestTicket: "Средний чек",
      suggestNearby: "Рекомендуемые ближайшие улицы",
      suggestRentLabel: "Средняя аренда 30/40 м²",
      suggestMapLabel: "Расположение на карте",
      macroStreetsLabel: "Рекомендуемые улицы",
      strengthsLabel: "Сильные стороны",
      passaggioLabel: "Проходимость",
      parcheggioLabel: "Парковка",
      utentiLabel: "Категория пользователей",
      ticketAvgLabel: "Средний чек",
      receiptsDayLabel: "Чеков/день (18ч)",
    },
    franchise: {
      label: "Франшиза",
      title: "Станьте партнёром RISORICE®",
      subtitle: "Эксклюзивная бизнес-модель, объединяющая технологии, итальянскую кухню без глютена и масштабируемый формат. Сопровождаем вас от идеи до открытия: маркетинг, обучение и облачное ПО управления.",
      benefits: [
        { title: "Food-Box Wall", body: "Получение по QR или PIN. Без очередей, без контакта, без ошибок." },
        { title: "AI Concierge", body: "Виртуальный ассистент, который рекомендует блюда и учитывает аллергии." },
        { title: "Приготовление MAGNETRON 5 мин", body: "MICHELCHEF® готовит каждое блюдо за 300 секунд, стабильно 24/7." },
        { title: "ИИ-управление", body: "Автозаказы, контроль маржи, прогноз продаж." },
        { title: "100% без глютена", body: "Кухня, сертифицированная AIC. Принимаются талоны SSN." },
        { title: "Масштабируемо", body: "От 20 м² со стеной на 6 боксов до точек 60 м² с 12+ боксами." },
      ],
      formTitle: "Запросить информацию",
      formSubtitle: "Перезвоним в течение 48 часов.",
      form: {
        name: "Имя и фамилия",
        email: "Email",
        phone: "Телефон",
        city: "Интересующий город",
        budget: "Бюджет инвестиций",
        budgetOptions: ["Менее 50k€", "50k€ – 100k€", "100k€ – 200k€", "Более 200k€"],
        message: "Расскажите о себе (необязательно)",
        submit: "Отправить запрос",
        sending: "Отправка...",
        success: "Запрос отправлен! Перезвоним в течение 48 часов.",
        error: "Ошибка отправки. Повторите попытку.",
      },
    },
    footer: {
      tagline: "Автоматизированная итальянская кухня · 100% без глютена · доставка и навынос",
      contact: "Контакты",
      emails: ["info@risorice.it", "franchising@risorice.it"],
      company: "RISORICE® S.r.l. · РИМ",
      certTitle: "Сертификаты",
      certs: ["Перечёркнутый колос AIC", "ISO 9001:2015", "Талоны SSN для целиаков"],
      rights: "© 2026 RISORICE® · Все права защищены",
      nav: "Навигация",
    },
    franchisingPage: {
      kicker: "ФРАНШИЗА · ИТАЛИЯ",
      title: "Откройте свой RISORICE®",
      subtitle: "Автоматизированная итальянская кухня без глютена. Уникальная ресторанная модель, объединяющая автоматическое приготовление, ИИ и Food-Box Wall.",
      stats: [
        { prefix: "€ ", value: 12, suffix: "", label: "Средний чек" },
        { prefix: "", value: 180, suffix: "+", label: "Возможных мест/день" },
        { prefix: "€ ", value: 90, suffix: "k", label: "Начальные инвестиции" },
        { prefix: "", value: 24, suffix: " мес.", label: "Ожидаемый ROI" },
      ],
      benefitsTitle: "Почему RISORICE®",
      benefitsSub: "6 конкурентных преимуществ, которые нас отличают",
      benefits: [
        { title: "Food-Box Wall", body: "Автоматизированная стена: клиент забирает свой бокс по QR/PIN, без очереди на кассе." },
        { title: "AI Concierge", body: "Чат-бот, который рекомендует блюда, собирает миски, учитывает аллергии и предпочтения." },
        { title: "Приготовление за 5 минут", body: "Каждое блюдо готово за 5 минут из сертифицированной центральной кухни без глютена." },
        { title: "Талоны SSN для целиаков", body: "Принимаем талоны SSN напрямую — интегрированная система погашения." },
        { title: "Интегрированное управление", body: "Админ-панель для заказов в реальном времени, статистики продаж и автозаказов." },
        { title: "Масштабируемая локация", body: "Стена настраивается от 6 до 12+ боксов в зависимости от вашего пространства." },
      ],
      stepsTitle: "Как это работает",
      steps: [
        { n: "1", title: "Контакт", body: "Заполняете форму — перезваниваем в течение 48ч." },
        { n: "2", title: "Оценка", body: "Оценка помещения + персональный бизнес-план для вашего района." },
        { n: "3", title: "Установка", body: "Wall Box, автоматизированная кухня MAGNETRON и брендированное приложение." },
        { n: "4", title: "Обучение", body: "Обучение персонала + маркетинговая и облачная поддержка." },
      ],
      simCtaTitle: "Хотите узнать, как профинансировать ваш RISORICE®?",
      simCtaBody: "Откройте калькулятор: полный анализ инвестиций €90k, ежемесячные платежи, точка безубыточности по чекам и окупаемость.",
      simCtaBtn: "Открыть калькулятор",
      assessTitle: "Оценка помещения с ИИ",
      assessSub: "Загрузите план и получите мгновенную оценку планировки, P&L и пригодности.",
      formTitle: "Запросить информацию",
      formSubtitle: "Перезвоним в течение 48 часов.",
    },
    simulator: {
      kicker: "КАЛЬКУЛЯТОР ИНВЕСТИЦИЙ",
      title: "Как профинансировать ваши € 90 000?",
      subtitle: "Рассчитайте ежемесячный платёж, точку безубыточности по чекам и окупаемость вашего RISORICE®. Полный анализ — на 100% ориентировочно, без регистрации.",
      breakdownTitle: "Из чего состоят € 90k",
      breakdown: [
        { label: "Паушальный взнос и роялти-сетап", value: "€ 15 000" },
        { label: "Wall Box + оборудование MAGNETRON", value: "€ 35 000" },
        { label: "Мебель и обустройство помещения", value: "€ 18 000" },
        { label: "Монтаж, инженерия, вывески", value: "€ 12 000" },
        { label: "Маркетинг запуска и первичные запасы", value: "€ 7 000" },
        { label: "Резерв (5%)", value: "€ 3 000" },
      ],
      modeTitle: "1. Выберите способ финансирования",
      modes: [
        { key: "banca", label: "Банк", desc: "Классический банковский кредит с первым взносом и французским планом амортизации. Ставка зависит от кредитной оценки." },
        { key: "leasing", label: "Лизинг", desc: "Лизинг оборудования с финальным выкупом. Небольшой первый взнос и налоговые преимущества по вычету платежей." },
        { key: "noleggio", label: "Аренда", desc: "Фиксированный ежемесячный all-inclusive платёж за весь сетап RISORICE®: оборудование, страховка, обслуживание и поддержка. Без первого взноса." },
      ],
      paramsTitle: "2. Первый взнос и срок",
      anticipoLabel: "Первый взнос",
      durataLabel: "Срок",
      tanLabel: "Ставка",
      months: "мес.",
      rateTitle: "3. Ваш платёж",
      rateSuffix: "в месяц · на",
      anticipoIniziale: "Первоначальный взнос",
      totInteressi: "Всего процентов",
      costoTotale: "Полная стоимость операции",
      beTitle: "4. Точка безубыточности — сколько нужно продавать",
      beIntro: "Начинаем с осторожного допущения в 60 чеков/день. RISORICE® работает 18-24ч/день, поэтому 150-260 чеков/день достижимы.",
      ticketLabel: "Средний чек",
      scontriniLabel: "Чеков/день",
      beCover: "чеков/день, чтобы покрыть только платёж",
      beDailyCost: "Дневная стоимость платежа",
      beYourEst: "Ваша оценка",
      beSafety: "Запас прочности",
      paybackTitle: "5. Окупаемость — когда вернёте вложения",
      marginLabel: "Чистая операционная маржа",
      ricavoMensile: "Оценка месячной выручки",
      utileNetto: "Чистая прибыль после платежа",
      utileSuffix: "в месяц",
      paybackLabel: "Окупаемость инвестиций",
      paybackYears: "лет",
      amortTitle: "6. Амортизация — первые 6 месяцев",
      amortIntro: "Детализация основного долга и процентов за первые месяцы плана.",
      amortCols: ["Месяц", "Платёж", "Проценты", "Основной долг", "Остаток долга"],
      disclaimer: "Чисто ориентировочный расчёт. Ставки, первый взнос и сроки зависят от оценки банков и лизинговых компаний, кредитоспособности и возможных льгот. Выручка и маржа — средние показатели формата RISORICE® и меняются в зависимости от локации. Не является офертой или финансовой консультацией.",
      bpBadge: "ПРЕМИУМ-УСЛУГА · € 99",
      bpTitle: "Нужен банковский бизнес-план?",
      bpBody: "Создаём профессиональный бизнес-план + питч для банка, адаптированный под вашу локацию. Финансовый анализ, прогнозы на 5 лет, безубыточность, ROI и план инвестиций.",
      bpFeatures: [
        "Полный бизнес-план (25-40 страниц) в PDF",
        "Банковский питч-дек (15 слайдов) в PDF и PPT",
        "Детальный P&L · трёхлетний денежный поток",
        "План инвестиций + финансовая потребность",
        "Анализ рынка под вашу локацию",
        "Доставка по email в течение 7 рабочих дней",
      ],
      bpPrice: "€ 99,00",
      bpPriceNote: "разово · с НДС",
      bpButton: "Запросить бизнес-план",
      bpNote: "Нужны план помещения, несколько фото внутри и снаружи и адрес — так мы оценим работы и проверим парковку.",
      bpModal: {
        title: "Ваши данные",
        subtitle: "Введите свои данные перед оплатой: нам нужно знать, кто покупает и куда отправить бизнес-план.",
        name: "Имя и фамилия",
        email: "Email",
        phone: "Телефон",
        city: "Город / расположение точки",
        submit: "Перейти к оплате · € 99",
        cancel: "Отмена",
        required: "Введите корректные имя и email.",
      },
      brochure: {
        badge: "Брошюра для инвесторов",
        title: "Скачать брошюру для инвесторов",
        body: "Лаконичный и убедительный документ: видение, модель, цифры калькулятора, ROI и безопасность. Почему RISORICE стремится стать больше McDonald's.",
        cta: "Скачать PDF",
        formTitle: "Перед скачиванием",
        formSubtitle: "Введите свои данные, чтобы получить брошюру для инвесторов.",
        name: "Имя и фамилия",
        email: "Email",
        phone: "Телефон",
        submit: "Скачать брошюру",
        sending: "Подождите...",
        required: "Введите корректные имя, email и телефон.",
        downloading: "Загрузка началась!",
        shareLabel: "Поделиться брошюрой",
        shareWhatsapp: "WhatsApp",
        shareEmail: "Email",
        shareText: "Откройте RISORICE — брошюра для инвесторов:",
        emailSubject: "RISORICE — Брошюра для инвесторов",
      },
      ctaTitle: "Убедили цифры?",
      ctaBody: "Заполните форму, и мы перезвоним в течение 48ч с персональным бизнес-планом для вашего района.",
    },
  },
};
